/* ============================================================
   La Cana — Tarjeta de regalo con dedicatoria
   assets/gift-note.js

   Guarda De / Para / Dedicatoria como propiedades de la línea del
   producto "Tarjeta de regalo", de modo que el cargo de $10 entra
   realmente al carrito y la dedicatoria viaja con el pedido.

   Depende de jQuery (ya cargado por el tema) sólo para reutilizar
   el refresco de la página de carrito. El resto es JS nativo.
   ============================================================ */
(function () {
  'use strict';

  var MODAL_ID = 'lc-gift-modal';

  function $one(sel, ctx) { return (ctx || document).querySelector(sel); }

  function root() { return document.getElementById('cart-gift-wrap'); }
  function modal() { return document.getElementById(MODAL_ID); }

  /* ---------- Utilidades ---------- */

  function setLoading(on) {
    var btn = $one('[data-gift-confirm]');
    if (!btn) return;
    btn.disabled = on;
    var spin = $one('.lc-gift-spinner', btn);
    var label = $one('[data-gift-confirm-label]', btn);
    if (spin) spin.hidden = !on;
    if (label) label.style.opacity = on ? '0.5' : '1';
  }

  function showError(msg) {
    var el = $one('[data-gift-error]');
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function updateCounter() {
    var ta = document.getElementById('note-note');
    var out = $one('[data-gift-count]');
    if (ta && out) out.textContent = ta.value.length;
  }

  /* ---------- Abrir / cerrar ---------- */

  var lastFocus = null;

  function openModal() {
    var m = modal();
    if (!m) return;
    lastFocus = document.activeElement;
    m.hidden = false;
    document.body.classList.add('lc-gift-open');
    showError('');
    updateCounter();
    var first = document.getElementById('note-from');
    if (first) setTimeout(function () { first.focus(); }, 60);
  }

  function closeModal() {
    var m = modal();
    if (!m) return;
    m.hidden = true;
    document.body.classList.remove('lc-gift-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Refresco del carrito ---------- */
  /* Reutiliza el mismo enfoque del tema: pedir /cart y sustituir
     los bloques renderizados, para que subtotal y total se recalculen
     con los datos reales del servidor. */
  function refreshCart() {
    return fetch('/cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var pairs = [
          ['cart-items', 'cart-items'],
          ['#main-cart-footer', '#main-cart-footer']
        ];

        pairs.forEach(function (p) {
          var nuevo = doc.querySelector(p[0]);
          var viejo = document.querySelector(p[1]);
          if (nuevo && viejo) viejo.innerHTML = nuevo.innerHTML;
        });

        // Contador del header
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-header .count, .cart_count, .navbar-cart-qty')
              .forEach(function (el) { el.textContent = cart.item_count; });

            if (cart.item_count === 0) window.location.reload();
          });
      });
  }

  /* ---------- Guardar la dedicatoria ---------- */

  function confirmNote() {
    var r = root();
    if (!r) return;

    var variantId = r.getAttribute('data-gift-variant');
    var lineKey = r.getAttribute('data-gift-line-key');

    var de = (document.getElementById('note-from') || {}).value || '';
    var para = (document.getElementById('note-to') || {}).value || '';
    var msg = (document.getElementById('note-note') || {}).value || '';

    de = de.trim(); para = para.trim(); msg = msg.trim();

    if (!de || !para) {
      showError('Escribe el nombre de quien regala y de quien recibe.');
      return;
    }
    if (!msg) {
      showError('Escribe tu dedicatoria.');
      return;
    }

    showError('');
    setLoading(true);

    var props = { 'De': de, 'Para': para, 'Dedicatoria': msg };

    /* Si la tarjeta ya está en el carrito, hay que quitarla antes de
       volver a agregarla: Shopify trata cada combinación de propiedades
       como una línea distinta y no permite editarlas en su lugar. */
    var paso = lineKey
      ? fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        })
      : Promise.resolve();

    paso
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1, properties: props }]
          })
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Error'); });
        return res.json();
      })
      .then(function () {
        closeModal();
        return refreshCart();
      })
      .catch(function (err) {
        showError(err.message || 'No pudimos agregar la tarjeta. Intenta de nuevo.');
      })
      .then(function () { setLoading(false); });
  }

  /* ---------- Quitar la tarjeta ---------- */

  function removeGift() {
    var r = root();
    if (!r) return;
    var lineKey = r.getAttribute('data-gift-line-key');
    if (!lineKey) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function () { return refreshCart(); })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- Delegación de eventos ----------
     Delegado en document porque el bloque se re-renderiza
     completo cada vez que el carrito cambia. */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-gift-open]')) { e.preventDefault(); openModal(); return; }
    if (e.target.closest('[data-gift-close]')) { e.preventDefault(); closeModal(); return; }
    if (e.target.closest('[data-gift-confirm]')) { e.preventDefault(); confirmNote(); return; }
    if (e.target.closest('[data-gift-remove]')) { e.preventDefault(); removeGift(); return; }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'note-note') updateCounter();
  });

  document.addEventListener('keydown', function (e) {
    var m = modal();
    if (!m || m.hidden) return;

    if (e.key === 'Escape') { closeModal(); return; }

    // Mantiene el foco dentro del modal mientras está abierto.
    if (e.key === 'Tab') {
      var focusables = m.querySelectorAll('button, input, textarea, [href]');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
